/**
 * 'Schematic' tab identifier of the tabbed content (solutions) panel
 * @type {string}
 */
export const SCHEMATIC_TAB = 'Schematic';

/**
 * 'Evaluation Kits' tab identifier of the tabbed content panel
 * @type {string}
 */
export const EVALKITS_TAB = 'Evaluation Kits';

/**
 * 'Samples' tab identifier of the tabbed content panel
 * @type {string}
 */
export const SAMPLES_TAB = 'Sample Kits';

/**
 * Eval kits model variant for SensorModels component
 * @type {string}
 */
export const MODEL_VARIANT_EVALKITS = 'evalKits';

/**
 * Samples model variant for SensorModels component
 * @type {string}
 */
export const MODEL_VARIANT_SAMPLES = 'samples';
